import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TicketClientApiService } from 'src/app/core/service/apis/tickets/ticket-client-api.service';
import { ConstitutionTicket } from '../../domain/models/constitution-ticket.model';
import { ConstitutionTicketsRepository } from '../../domain/repository/constitution-tickets.repository';
import { ConstitutionTicketMapperService } from '../mappers/constitution-ticket-mapper.service';

@Injectable()
export class HttpConstitutionTicketsRepository implements ConstitutionTicketsRepository {
  constructor(
    private readonly ticketClientApi: TicketClientApiService,
    private readonly mapper: ConstitutionTicketMapperService,
  ) { }

  getAllTicketsByRecordIdConstitution(constitutionRecordId: string): Observable<ConstitutionTicket[]> {
    return this.ticketClientApi.findAllTickets({
      recordIdConstitution: [constitutionRecordId],
    }).pipe(
      map((tickets) => tickets.map(ticket => this.mapper.toConstitutionTicket(ticket))),
    );
  }
}
